// Currency code → display symbol map.
//
// Mirrors the server-side DEFAULT_CURRENCIES list in
// /app/backend/routes/settings.py so the on-screen and exported glyphs
// stay in lockstep. When an estimate uses a code not in this map we
// fall back to "$" so costs never render as bare numbers.
const CURRENCY_SYMBOLS = {
  USD: '$',
  AUD: 'A$',
  GBP: '£',
  EUR: '€',
  CAD: 'C$',
  NZD: 'NZ$',
  JPY: '¥',
  SGD: 'S$',
  HKD: 'HK$',
  CHF: 'CHF ',
  INR: '₹',
};

export function getCurrencySymbol(code, fallback = '$') {
  if (!code) return fallback;
  return CURRENCY_SYMBOLS[String(code).toUpperCase()] || fallback;
}

// Tax descriptor per currency. Mirrors `CURRENCY_TAX_LABELS` in
// /app/backend/routes/quote_helpers.py — descriptive only, no calc.
const CURRENCY_TAX_LABELS = {
  AUD: { name: 'GST', excluding: 'Excluding GST', including: 'Including GST' },
  NZD: { name: 'GST', excluding: 'Excluding GST', including: 'Including GST' },
  SGD: { name: 'GST', excluding: 'Excluding GST', including: 'Including GST' },
  INR: { name: 'GST', excluding: 'Excluding GST', including: 'Including GST' },
  GBP: { name: 'VAT', excluding: 'Excluding VAT', including: 'Including VAT' },
  EUR: { name: 'VAT', excluding: 'Excluding VAT', including: 'Including VAT' },
  CHF: { name: 'VAT', excluding: 'Excluding VAT', including: 'Including VAT' },
  USD: { name: 'Taxes', excluding: 'Excluding Taxes', including: 'Including Taxes' },
  CAD: { name: 'Taxes', excluding: 'Excluding Taxes', including: 'Including Taxes' },
  JPY: { name: 'Taxes', excluding: 'Excluding Taxes', including: 'Including Taxes' },
  HKD: { name: 'Taxes', excluding: 'Excluding Taxes', including: 'Including Taxes' },
};

export function getTaxLabel(currencyCode, taxInclusive = false) {
  const code = String(currencyCode || 'USD').toUpperCase();
  const cfg = CURRENCY_TAX_LABELS[code] || CURRENCY_TAX_LABELS.USD;
  return {
    code,
    name: cfg.name,
    excluding: cfg.excluding,
    including: cfg.including,
    applied: taxInclusive ? cfg.including : cfg.excluding,
    taxInclusive,
  };
}
